
import { createGlobalStyle } from 'styled-components';

const BlogStyles = createGlobalStyle`
.blog-container {
    .related-article__title {
        font-family: "jubilat-variable",sans-serif;
        font-variation-settings: 'wght' 350;
        font-size: 1.5rem;
        font-weight: 700;
        margin-bottom: 40px;
    }
}
`;

export default BlogStyles;